/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductMappingResponse } from '../../models/product-mapping-response';

export interface GetProductMapping$Params {
  productMappingId: string;
}

export function getProductMapping(http: HttpClient, rootUrl: string, params: GetProductMapping$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductMappingResponse>> {
  const rb = new RequestBuilder(rootUrl, getProductMapping.PATH, 'get');
  if (params) {
    rb.path('productMappingId', params.productMappingId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductMappingResponse>;
    })
  );
}

getProductMapping.PATH = '/product-mapping/{productMappingId}';
